import { Tag, TagLabel, Text, Flex, Heading, Box, Image, SimpleGrid, Grid, forwardRef, GridProps } from "@chakra-ui/react"
import { AvatarCard } from "@components/Cards/AvataraCard/AvatarCard";
import { MetaCard } from "@components/Cards/MetaCard/MetaCard";
import { WidgetTitle } from "@components/Texts/WidgetTitle/WidgetTitle";
import { generatePageUrl, preparePostUrl } from "@core/utils";
import { Link } from "@reach/router";
import React from "react";
import { CATEGORY_MODES } from "../categoryModes.enum";
import { TileAvatar } from "@components/Tiles/Tile";

const categoryBorderOptions = {
    [CATEGORY_MODES.BASE]: '#D1E6FF',
    [CATEGORY_MODES.ASK_QUESTIONS]: '#E40073'
}

export const PrimaryPostTile = forwardRef<GridProps, "div">(({ post, tag, mode = CATEGORY_MODES.BASE, ...rest }, ref) => {
    const { author, slug, title, excerpt, featuredImage, categories: { nodes: [firstCategory] } } = post;
    return (
        <Grid as={Link} to={preparePostUrl(post)} templateColumns={{base: "repeat(1, 1fr)", md: "repeat(2, 1fr)"}} gap={10} ref={ref} {...rest}>
            <Box position="relative">
                <Image loading="lazy" src={featuredImage?.node?.blogBig} alt="" maxH="278px" w="100%" objectFit="cover" />
                {tag && (
                  <>
                      <Tag d={{base: 'none', md: 'block'}} position="absolute" top="28px" left="-11px"
                           size="sm" borderRadius="none" variant="solid" color="#FFFFFF" cursor="pointer"
                           backgroundColor="#E40073" px="8px" py="6px" mr="5px" mb="5px">
                          <TagLabel textTransform="uppercase" fontSize="12px" fontWeight="700">OSTATNI WPIS</TagLabel>
                      </Tag>
                      <Tag d={{base: 'block', md: 'none'}} position="absolute" bottom="21px" left="0"
                           size="sm" borderRadius="none" variant="solid" color="#FFFFFF" cursor="pointer"
                           backgroundColor="#E40073" px="8px" py="6px" mr="5px" mb="5px">
                          <TagLabel textTransform="uppercase" fontSize="12px" fontWeight="700">OSTATNI WPIS</TagLabel>
                      </Tag>
                  </>
                )}
                <Flex>
                    <TileAvatar color="white" d={{base: 'flex', md: 'none'}} w="100%" position="absolute" top="11px" left="11px" author={author} />
                </Flex>
            </Box>
            <Box>
                <Flex d={{base: 'none', md: 'flex'}} justifyContent="space-between" mb="18px">
                    <WidgetTitle borderLeftColor={categoryBorderOptions[mode]}>{firstCategory.name}</WidgetTitle>
                    <MetaCard article={post} />
                </Flex>

                <Heading fontSize="26px" mb="10px">{title}</Heading>
                <Box d={{base: 'none', md: 'block'}} sx={{
                    'a.more-link': {
                        'display': 'none',
                    }
                }} dangerouslySetInnerHTML={{ __html: excerpt }} mb="10px" />
                <AvatarCard d={{base: 'none', md: 'block'}} author={author} />
                <Box d={{base: 'block', md: 'none'}}>
                    <MetaCard article={post} />
                </Box>
            </Box>
        </Grid>
    )
});
